import "vue-utils/dist/style.css"
import "./bootstrap.scss"

import "./app.scss"

import "./utils/extensions"

import { isInPopup } from "oidc-vue"
import { createPinia } from "pinia"
import { createApp } from "vue"
import App from "./App"
import { AppAuthContext } from "./Authentication"
import router from "./pages/routes"

AppAuthContext.options.router = router
await AppAuthContext.initialize()

if (!isInPopup()) {
	try {
		if (await AppAuthContext.needsSignIn()) {
			AppAuthContext.user = null
		}
	} catch (e) {
		console.error(e)
	}

	const app = createApp(App)
	app.use(createPinia())
	app.use(router)
	app.use(AppAuthContext)

	if (document.readyState === "loading") {
		await new Promise((resolve) => document.addEventListener("DOMContentLoaded", resolve))
	}

	app.mount("#app")
}
